import { TRAINING_PERIOD_LIMITS } from '../constants';

export const validateTrainingPeriodCount = (
  value: number | undefined,
  periodType: string | undefined,
  allowEmpty = false,
): boolean => {
  if (value == null || isNaN(Number(value))) {
    return allowEmpty;
  }
  const normalizedValue = Number(value);
  if (!Number.isInteger(normalizedValue)) {
    return false;
  }
  const periodLimits = TRAINING_PERIOD_LIMITS[periodType ?? 'day'];
  if (!periodLimits) return false;
  return (
    normalizedValue >= periodLimits.min && normalizedValue <= periodLimits.max
  );
};

export const EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

export const isValidEmail = (email: string): boolean => {
  const emailRegex = new RegExp(`^${EMAIL_PATTERN.source}$`);
  return emailRegex.test(email.trim());
};

export const extractEmailsFromText = (text: string): string[] => {
  const emailRegex = new RegExp(EMAIL_PATTERN.source, 'g');
  const matches = text.match(emailRegex);
  return matches ? [...new Set(matches)] : [];
};

export const isStrongPassword = (password: string) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
  return passwordRegex.test(String(password));
};

export const isValidUrl = (url: string) => {
  const urlRegex =
    /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\\/~+#-]*[\w@?^=%&\\/~+#-])/i;
  return urlRegex.test(url);
};
